"use client"

import { FaWhatsapp } from 'react-icons/fa'
import { siteConfig } from '@/config/site'

export function FloatingWhatsAppButton() {
  const whatsappPhone = siteConfig.whatsapp.replace(/[^\d+]/g, '')
  const whatsappUrl = `https://wa.me/${whatsappPhone}?text=Hi%2C%20I%20would%20like%20to%20book%20an%20appointment`

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 transition-all duration-300 transform hover:scale-110 active:scale-95"
      aria-label="Chat with us on WhatsApp"
    >
      <FaWhatsapp className="w-7 h-7 md:w-8 md:h-8" />
    </a>
  )
}
